<ion-button
    class="add-edit-card-form-button w-full overflow-hidden rounded-md"
    [attr.aria-label]="(mode === 'add' ? 'ADD_NEW_CARD' : 'SAVE') | translate"
    [disabled]="cardForm?.invalid"
    [expand]="isMobileView ? 'block' : 'inline-block'"
    (click)="submit()"
    size="large">
    <ion-label
        class="tallinn-light:text-white tartu-light:text-white gl-light:text-[var(--color-primary)] flex items-center gap-2 text-base font-semibold normal-case leading-5">
        {{ (mode === 'add' ? 'ADD_NEW_CARD' : 'SAVE') | translate }}
        <ion-icon
            class="tallinn-light:text-white text-xl"
            name="arrow-forward-outline"
            slot="end"
            aria-hidden="true"></ion-icon>
    </ion-label>
</ion-button>
